import { faBan } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import {
    MotivoNaoProcedenciaController,
    SolicitacaoNaoProcedenteController,
} from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { ISolicitacaoNaoProcedenteAvaliar } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/SolicitacaoNaoProcedente/SolicitacaoNaoProcedente";

interface ISolicitacaoNaoProcedenteProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function SolicitacaoNaoProcedente(
    props: ISolicitacaoNaoProcedenteProps
) {
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: executarFormSolicitacaoNaoProcedente, loading } =
        useAsyncCallback(SolicitacaoNaoProcedenteController);

    const handleSolicitacaoNaoProcedenteFormSubmit = (
        formData: ISolicitacaoNaoProcedenteAvaliar
    ) => {
        executarFormSolicitacaoNaoProcedente("ConstrutoraAvaliara", {
            ...formData,
            DadosCustos: { ID_CASO },
        }).then(() => {
            updateAtendimento();
            ReloadHistorico();
            props.setShow(false);
        });
    };

    const { execute: listarMotivosNaoProcedencia } = useAsyncCallback(
        () => MotivoNaoProcedenciaController(ID_CASO),
        [ID_CASO]
    );

    return (
        <UnForm handleSubmit={handleSolicitacaoNaoProcedenteFormSubmit}>
            <div className="mb-8">
                <div className="row m-0 ">
                    {Atendimento ? (
                        <UnForm.LazySelect
                            registerOptions={{
                                required: "Insira um motivo de não procedência",
                            }}
                            controller={listarMotivosNaoProcedencia}
                            label="Motivo de Não Procedência"
                            name="idMotivo"
                            className={`form-control placeholder-dark-50`}
                            wrapperClassName="col-12 col-md-12 m-0"
                            getDS={(p) => p.DS_MOTIVO_NAO_PROCEDENCIA}
                            getKeyValue={(p) => p.ID_MOTIVO_NAO_PROCEDENCIA}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    ) : null}
                </div>
            </div>
            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Textarea
                        registerOptions={{
                            required: "Insira uma Descrição",
                        }}
                        name="DescricaoMotivo"
                        label="Descrição"
                        noRezise
                        rows={6}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>
            <UnForm.SubmitButton
                color="success"
                wrapperClassName="w-100 mt-8"
                className="w-100"
                icon={faBan}
                loading={loading}
                disabled={loading}
                loadingSize={"sm"}
            >
                Solicitação Não Procedente
            </UnForm.SubmitButton>
        </UnForm>
    );
}
